import React from 'react';
import {
  Row,
  Col,
  Input,
  Typography,
  Table,
  message,
  Tag,
  Statistic,
  Skeleton,
  Result,
  Button,
  Form,
  Select,
  DatePicker
} from 'antd'
import {
  FaPlusCircle,
  FaSearch,
  FaRegCreditCard,
  FaBitcoin
} from "react-icons/fa"; //Font Awesome 5
import {
  // useParams,
  useNavigate
} from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { formatPhone, paymentTypes } from '../../utils/customFunctions';
import axios from '../../config/axios';

const billingStatus = [
  // { key: 'created', label: 'CREATED', value: 'CREATED' },
  { key: 'completed', label: 'COMPLETED', value: 'COMPLETED' },
  { key: 'canceled', label: 'CANCELED', value: 'CANCELED' },
]
const columns = [
  {
    title: 'Date',
    dataIndex: 'order_date',
    key: 'order_date',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {dayjs(text).format('DD-MM-YYYY')}
      </Button>
  },
  {
    title: 'Order no.',
    dataIndex: 'order_no',
    key: 'order_no',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'Student',
    dataIndex: 'student',
    key: 'student',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text?.fname_th} {text?.lname_th}
      </Button>
  },
  {
    title: 'Student ID',
    dataIndex: 'student',
    key: 'student',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text.student_code}
      </Button>
  },
  {
    title: 'Phone',
    dataIndex: 'student',
    key: 'student',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {formatPhone(text.parent.phone)}
      </Button>
  },
  {
    title: 'Amount',
    dataIndex: 'grand_total',
    key: 'grand_total',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
      </Button>
  },
  {
    title: 'Payment Type',
    dataIndex: 'payment_type',
    key: 'payment_type',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record._id}`}
        icon={text === 'CASH' ? <FaBitcoin /> : <FaRegCreditCard />}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left',
          color: text === 'CASH' ? "#55C522" : "#3487FF"
        }}>
        {text}
      </Button>
  },
  {
    title: 'Status',
    dataIndex: 'order_status',
    key: 'order_status',
    align: 'center',
    render: (text, _) => <Tag color={text === 'COMPLETED' ? "green" : "red"} style={{ borderRadius: '20px' }}>{text}</Tag>
  },
  // {
  //   title: '',
  //   dataIndex: 'action',
  //   key: 'action',
  //   render: (_, record) => (
  //     <Space size="middle">
  //       <DeletePopupButton data={record}/>
  //       <EditFormModal data={record} categories={categories}/>
  //     </Space>
  //   ),

  // }
]

function List() {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const redirect = useNavigate();
  // const { searchQuery, billstatus, date } = useParams();
  // const ordersQuery = useQuery({ queryKey: ['/api/orderItems/completedOrders'] });
  // const ordersQuery = useQuery({ queryKey: ['/api/orders/getNotOrderCreate',filterData] });
  const ordersQuery = useQuery({ queryKey: ['/api/orders/getNotOrderCreate'] });
  const productQuery = useQuery({ queryKey: ['/api/products/getAllCourseProducts'] });
  if (ordersQuery.isLoading || productQuery.isLoading) {
    return <Skeleton active />
  }

  if (ordersQuery.isError || productQuery.isError) {
    return <Result
      status="error"
      title={ordersQuery.error.message || productQuery.error.message} />
  };

  const onSearch = e => {
    form
      .validateFields()
      .then(info => {

        let searchText = `/admin/orders/searchOrder?`;
        if (info.date) {
          searchText += `&start_date=${dayjs(info.date[0]).format('YYYY-MM-DD')}`;
          searchText += `&end_date=${dayjs(info.date[1]).format('YYYY-MM-DD')}`;
        }
        if (info.product) searchText += `&product=${info.product}`;
        if (info.payment_type) searchText += `&payment_type=${info.payment_type}`;
        if (info.order_status) searchText += `&order_status=${info.order_status}`;
        if (info.q) searchText += `&q=${info.q}`;

        redirect(searchText);
      })
      .catch(err => {
        console.log(err)
      })
  }

  const createNewOrder = async () => await axios.get('/api/orders/getNewOrder')
    .then(res => redirect(`/admin/orders/create/${res.data._id}`))
    .catch(err => {
      console.log(err)
      messageApi.open({
        type: 'error',
        content: 'Update failed!',
      })
    });
  // console.log('ordersQuery.data :', ordersQuery.data);
  // console.log('productQuery.data :', productQuery.data);
  return (
    <div >
      {contextHolder}
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Row justify='space-between'>
            <Col>
              <Typography.Title level={3}>
                Orders
              </Typography.Title>
            </Col>
            <Col>
              <Button
                type='primary'
                icon={<FaPlusCircle />}
                onClick={createNewOrder}>Create</Button>
            </Col>
          </Row>
        </Col>
        <Col xs={24} >
          <Row justify='space-between' gutter={[16, 16]}>
            <Col xs={24}>
              <Form
                form={form}
                name='searchOrders'
              >
                <Row justify='space-between' gutter={[8, 0]}>
                  <Col xs={24} md={8}>
                    <Form.Item name="date" label="">
                      <DatePicker.RangePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      label=""
                      name="payment_type"
                    >
                      <Select placeholder="Select payment type">
                        {paymentTypes.map(type => <Select.Option key={type.value} value={type.value}>
                          {type.label_th}
                        </Select.Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="order_status" label="">
                      <Select
                        placeholder="Select status"
                        showSearch
                        optionFilterProp="children"
                        allowClear
                      >
                        {billingStatus.map(status => <Select.Option key={status.key} value={status.value}>
                          {status.label}
                        </Select.Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label=""
                      name="product"
                    >
                      <Select placeholder="Select courses or other products">
                        {productQuery.data.map(p => <Select.Option key={p._id} value={p.id}>
                          {p.name}
                        </Select.Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col flex={1} >
                    <Form.Item label="" name="q">
                      <Input placeholder="Search Student name, Student ID or Phone" />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button
                      type='primary'
                      icon={<FaSearch />}
                      onClick={onSearch}
                      style={{ width: '100%' }}
                    >Search</Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={ordersQuery.data}
            scroll={{
              x: 800,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default List